






































import { Component } from 'nuxt-property-decorator'
import { ModalComponentBaseVue } from '@/base'
import { ModalFooter } from '@/components/molecules/ModalFooter'
import MailDetailInfo from '@/components/organisms/MailDetailInfo/MailDetailInfo.vue'
import { defaultMailHistory, MailHistory } from '@/api'
import MailDetailBody from '@/components/organisms/MailDetailBody/MailDetailBody.vue'

interface ModalMailDetailInterface {
  mailHistory: MailHistory
}

@Component({
  components: {
    MailDetailBody,
    MailDetailInfo,
    ModalFooter
  }
})
export default class ModalMailDetail extends ModalComponentBaseVue {
  dialog: boolean = false

  mailHistory: MailHistory = defaultMailHistory()

  tableHeight: number = 0

  open(params: ModalMailDetailInterface): void {
    this.dialog = true

    this.mailHistory = params.mailHistory
    this.$nextTick(this.calculateTableHeight)
    window.addEventListener('resize', this.calculateTableHeight)
  }

  close(): void {
    this.dialog = false
    this.mailHistory = defaultMailHistory()
    window.removeEventListener('resize', this.calculateTableHeight)
  }

  calculateTableHeight(): void {
    this.tableHeight = 0

    this.$nextTick(() => {
      this.tableHeight = this.calculateTableHeightBase()
    })
  }

  onClickPrint(): void {
    const element = document.getElementById('modal-mail-detail')
    if (element) {
      this.$webSocket.sendDialogScreenshotMessage(element)
    } else {
      this.$webSocket.sendScreenshotMessage()
    }
  }
}
